export const CHECK_ACCESS_TOKEN = 'CHECK_ACCESS_TOKEN'
export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN'
export const CLEAR_ACCESS_TOKEN = 'CLEAR_ACCESS_TOKEN'

export const CHECK_ACCOUNT_DETAILS = 'CHECK_ACCOUNT_DETAILS'
export const SET_ACCOUNT_DETAILS = 'SET_ACCOUNT_DETAILS'
export const CLEAR_ACCOUNT_DETAILS = 'CLEAR_ACCOUNT_DETAILS'

export const GET_WISHLIST = 'GET_WISHLIST'
export const GET_WISHLIST_SUCCESS = 'GET_WISHLIST_SUCCESS'
export const GET_WISHLIST_ERROR = 'GET_WISHLIST_ERROR'

export const GET_CART = 'GET_CART'
export const GET_CART_SUCCESS = 'GET_CART_SUCCESS'
export const GET_CART_ERROR = 'GET_CART_ERROR'

export const ADD_TO_WISHLIST = 'ADD_TO_WISHLIST'
export const ADD_TO_WISHLIST_SUCCESS = 'ADD_TO_WISHLIST_SUCCESS'
export const ADD_TO_WISHLIST_ERROR = 'ADD_TO_WISHLIST_ERROR'

export const REMOVE_FROM_WISHLIST = 'REMOVE_FROM_WISHLIST'
export const REMOVE_FROM_WISHLIST_SUCCESS = 'REMOVE_FROM_WISHLIST_SUCCESS'
export const REMOVE_FROM_WISHLIST_ERROR = 'REMOVE_FROM_WISHLIST_ERROR'

export const ADD_TO_CART = 'ADD_TO_CART'
export const ADD_TO_CART_SUCCESS = 'ADD_TO_CART_SUCCESS'
export const ADD_TO_CART_ERROR = 'ADD_TO_CART_ERROR'
export const ADD_TO_CART_RESET = 'ADD_TO_CART_RESET'

export const checkAccessToken = () => {
    return {type: CHECK_ACCESS_TOKEN}
}

export const setAccessToken = (token) => {
    return {type: SET_ACCESS_TOKEN, payload: token}
}

export const clearAccessToken = () => {
    return {type: CLEAR_ACCESS_TOKEN}
}

export const checkAccount = () => {
    return {type: CHECK_ACCOUNT_DETAILS}
}

export const setAccount = (account) => {
    return {type: SET_ACCOUNT_DETAILS, payload: account}
}

export const clearAccount = () => {
    return {type: CLEAR_ACCOUNT_DETAILS}
}

export const getWishlist = () => {
    return {type: GET_WISHLIST}
}

export const getCart = () => {
    return {type: GET_CART}
}

export const addToCart = (sku, simpleSku) => {
    return {type: ADD_TO_CART, payload: {sku, simpleSku}};
}

export const addToWishlist = (sku, simpleSku) => {
    return {type: ADD_TO_WISHLIST, payload: {sku, simpleSku}};
}

export const removeFromWishlist = (sku) => {
    return {type: REMOVE_FROM_WISHLIST, payload: {sku}};
}


// WEBPACK FOOTER //
// ./src/actions/account.js